<template>
  <a-row>
    <a-col :span="12">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :customRow="customRowFn"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <projectResultConfigItem-modal :resultList="resultList" ref="modalForm" @ok="modalFormOk"></projectResultConfigItem-modal>
      </a-card>
    </a-col>
    <a-col :span="12" >
      <project-result-config-item-child-list :configItemId="currentId"></project-result-config-item-child-list>
    </a-col>
  </a-row>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ProjectResultConfigItemModal from './modules/ProjectResultConfigItemModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import ProjectResultConfigItemChildList from './ProjectResultConfigItemChildList'
  export default {
    name: "ProjectResultConfigItemList",
    mixins:[JeecgListMixin],
    components: {
      ProjectResultConfigItemChildList,
      ProjectResultConfigItemModal
    },
    props:{
      resultList:{
        type:Array,
        default:()=>{
          return []
        }
      }
    },
    data () {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        description: '表单结果逻辑明细配置管理页面',
        // 表头
        columns: [
          {
            title: '测评类',
            align:"center",
            dataIndex: 'resultCategory'
          },
          {
            title: '测评名称',
            align:"center",
            dataIndex: 'name'
          },
          {
            title: '人群平均分',
            align:"center",
            dataIndex: 'personAvg'
          },
          {
            title: '是否显示',
            align:"center",
            dataIndex: 'view_dictText'
          },
       //
		   // {
       //      title: '测评分段配置',
       //      align:"center",
       //      dataIndex: 'config'
       //     },

          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/project/projectResultConfigItem/list",
          delete: "/project/projectResultConfigItem/delete",
       },
        isorter:{
          column: '',
          order: '',
        },
        disableMixinCreated:true,
        currentId:'',
    }
  },
  computed: {
  },
    mounted(){
      this.baseQueryParam = {projectId:this.projectId}
      this.loadData()
    },
    methods: {
      customRowFn(record) {
        return {
          on: {
            click: () => {
              this.currentId = record.id
            }
          }
        }
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>